import ArrowLeft from "../../../../assets/icons/Arrow/ArrowLeft";
import { UserOrder } from "../../../../store/slice/userSlice";
import OrderDetails from "../OrderDetails/OrderDetails";
import OrderCard from "./OrderCard";
import "./OrderList.scss";
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

const OrderList = ({ orders }: { orders: UserOrder[] }) => {
  const navigate = useNavigate();

  const [viewDetails, setViewDetails] = useState<string | undefined>(undefined);

  const handleViewOrder = (id: string) => {
    setViewDetails(id);
    // alert(`Voir commande #${id}`);
  };

  const orderTarget = useMemo(() => {
    return orders.find((order) => order.id === viewDetails);
  }, [viewDetails, orders]);

  const handleReportProblem = (id: string) => {
    // alert(`Signaler un problème pour la commande #${id}`);
    navigate(`/contact?orderReference=${id}`);
  };

  return (
    <div className="order-list">
      {viewDetails ? (
        <div className="order-header">
          <ArrowLeft onClick={() => setViewDetails(undefined)} />
          <h2>
            Commande {orderTarget?.id} - {orderTarget?.status}
          </h2>
        </div>
      ) : (
        <h2>Historique de mes commandes</h2>
      )}
      {viewDetails ? (
        <OrderDetails order={orderTarget} />
      ) : (
        orders.map((order) => (
          <OrderCard
            key={order.id}
            order={order}
            onViewOrder={handleViewOrder}
            onReportProblem={handleReportProblem}
          />
        ))
      )}
    </div>
  );
};

export default OrderList;
